export default {
    差价合约:'ETF CFD',
    把握全球:'เทรด ETF ยอดนิยมทั่วโลกกว่า 100 รายการ ครอบคลุม: หุ้น, พันธบัตร, อุตสาหกรรมเฉพาะภูมิภาค และกลุ่มปันผล โดยไม่ต้องมีบัญชีกองทุน เพิ่มโอกาสทำกำไรด้วยเลเวอเรจ และยังเทรดได้ทั้งขาขึ้น-ขาลง',
    即刻开户:'เปิดบัญชี',
    优势:'ข้อดี',
    差价合约是一种:'ETF CFD (สัญญาซื้อขายส่วนต่าง) คือผลิตภัณฑ์การเงินที่มีความยืดหยุ่น ช่วยให้นักเทรดสามารถเข้าถึง ETF ชั้นนำของโลกด้วยการใช้เลเวอเรจ เหมาะสำหรับผู้ที่ต้องการใช้โอกาสจากความเคลื่อนไหวของราคา และกระจายความเสี่ยงในพอร์ตลงทุน',
    品种丰富:'ตัวเลือกหลากหลาย',
    支持100:'รองรับการเทรด ETF CFD ยอดนิยมมากกว่า 100 รายการทั่วโลก',
    灵活交易:'กลยุทธ์ที่ยืดหยุ่น',
    支持买入:'"เทรดได้ทั้งฝั่งซื้อและฝั่งขายเพิ่มโอกาสทำกำไร ทั้งขาขึ้นและขาลง"',
    无需持有:'ไม่ต้องถือครองสินทรัพย์',
    无需持有资产:'เก็งกำไรจากการเคลื่อนไหวของราคา ETF โดยไม่ต้องเป็นเจ้าของสินทรัพย์',
    杠杆交易:'รองรับเลเวอเรจ',
    杠杆配置:'เข้าถึงเลเวอเรจ 5:1 เพิ่มประสิทธิภาพการใช้เงินทุนที่ต่ำกว่าเดิม',
    开设模拟账户:'เปิดบัญชีทดลอง',
    开设真实账户:'เปิดบัญชีจริง',
    如何开始交易:'วิธีเริ่มต้นการเทรด',
    注册账号:'สมัครเปิดบัญชี',
    注册并登录:'ลงทะเบียนและยืนยันตัวตนผ่านระบบศูนย์ผู้ใช้',
    下载MT5交易平台:'ดาวน์โหลด MT5',
    开通真实交易账号:'เปิดบัญชีเทรดบน MetaTrader 5',
    开始交易:'เริ่มเทรดทันที',
    选择ETF:'เลือกเทรดผลิตภัณฑ์ ETF CFD',
    即刻交易:'เริ่มเทรดตอนนี้',
    差价合约相关问题:'คำถามเกี่ยวกับ ETF CFD',
    有什么区别:'1.เทรด ETF CFD แตกต่างจาก ETF ทั่วไปอย่างไร?',
    是差价合约交易:'ETF CFD เป็นการซื้อขายส่วนต่างของราคา ETF โดยไม่ต้องถือครองสินทรัพย์จริง ไม่ต้องเปิดบัญชีหลักทรัพย์ และไม่ต้องจ่ายค่าธรรมเนียมฝากถอน เหมาะกับการเทรดระยะสั้น การใช้เลเวอเรจ และกลยุทธ์ทั้งขาขึ้น/ขาลง',
    购买ETF才能交易:'2.เทรด ETF ต้องถือสินทรัพย์จริงหรือไม่?',
    通过EBC提供的ETF:'ไม่ต้อง คุณสามารถเทรด ETF CFD และทำกำไรได้จากความผันผวนของราคาบนแพลตฟอร์ม EBC และไม่ต้องถือสินทรัพย์ ETF จริง',
    交易会收取哪些费:'3.เทรด ETF CFD มีค่าธรรมเนียมอะไรบ้าง?',
    您无需支付传统ETF的管理费:'ไม่มีค่าธรรมเนียมการจัดการแบบ ETF ปกติ ค่าธรรมเนียมหลักประกอบด้วยส่วนต่างราคา (Bid-Ask) และค่าถือข้ามคืน(สวอป) โดยรายละเอียดทั้งหมดแสดงแบบเรียลไทม์บนแพลตฟอร์ม',
    可以做空吗:'4.เทรด ETF CFD สามารถขายชอร์ตได้หรือไม่?',
    与传统ETF只能做多不:'ได้ ซึ่งแตกต่างจาก ETF แบบดั้งเดิมที่เปิดได้แค่สถานะซื้อ ETF CFD รองรับการขายชอร์ต ซึ่งช่วยให้มีความยืดหยุ่นในเชิงกลยุทธ์ทั้งในตลาดที่ผันผวนและในตลาดขาลง',
    适合新手交易者:'5.เทรด ETF CFD เหมาะกับมือใหม่ไหม?',
    CFD产品具有杠杆属性:'เนื่องจาก ETF CFD เป็นผลิตภัณฑ์ที่มีเลเวอเรจ (leverage) จึงเหมาะกับผู้ที่มีประสบการณ์การเทรด และมีความเข้าใจเรื่องความเสี่ยง หากเป็นเทรดเดอร์มือใหม่ ควรฝึกฝนด้วยบัญชีทดลอง (demo account) เพื่อทำความคุ้นเคยกับผลิตภัณฑ์ก่อนเริ่มเทรดจริง',
    市场报价:'อัตราฟอเร็กซ์',
    查看所有产品:'ผลิตภัณฑ์ทั้งหมด',
}